// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSmallPlayButton_root__KGmS0","svg":"PlasmicSmallPlayButton_svg__Wz+nx"};